import React from 'react';
import { Heart, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Heart className="w-6 h-6 text-blue-400" />
              <span className="text-xl font-semibold text-white">Understanding Grief</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Providing compassionate information and resources to help you navigate 
              the journey through grief and loss.
            </p>
            <div className="space-y-2">
              <p className="text-gray-300 font-semibold mb-2">Professional Grief Counseling:</p>
              <a href="mailto:mentorsplace@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Mail className="w-4 h-4" />
                <span className="text-sm">mentorsplace@gmail.com</span>
              </a>
              <a href="tel:3212620256" className="flex items-center gap-2 text-gray-400 hover:text-blue-400 transition-colors duration-200">
                <Phone className="w-4 h-4" />
                <span className="text-sm">(321) 262-0256</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#stages" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  The Five Stages
                </a>
              </li>
              <li>
                <a href="#resources" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  Resources
                </a>
              </li>
              <li>
                <a href="#support" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  Get Support
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Important Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Crisis Support</h3>
            <ul className="space-y-2">
              <li>
                <a href="tel:988" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  Suicide Prevention: 988
                </a>
              </li>
              <li>
                <a href="sms:741741" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  Crisis Text: 741741
                </a>
              </li>
              <li>
                <a href="tel:1-800-662-4357" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">
                  SAMHSA: 1-800-662-4357
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Understanding Grief. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="/privacy-policy" className="text-gray-400 hover:text-blue-400 text-sm transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 text-sm transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 text-sm transition-colors duration-200">
                Disclaimer
              </a>
            </div>
          </div>
          <p className="text-gray-500 text-xs mt-4 text-center md:text-left">
            This website provides general information about grief and loss. It is not a substitute for professional 
            medical advice, diagnosis, or treatment. If you're experiencing a mental health crisis, please call 988 immediately.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
